import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
    {
      title: 'Software Development',
      description: 'Custom web applications, enterprise platforms, and government systems.'
    },
    {
      title: 'IT Systems & Automation',
      description: 'Workflow automation, system integration, and digital transformation.'
    },
    {
      title: 'Web & Cloud Solutions',
      description: 'Websites, portals, cloud deployment, and hosting.'
    },
    {
      title: 'Digital Payments & Integrations',
      description: 'M-Pesa, Paybill, Paystack, billing and reconciliation systems.'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <h2 className="section-title">Our Services</h2>
        <p className="section-subtitle">
          Comprehensive technology solutions tailored to your business needs
        </p>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;

